<template>
  <div>
    <div class="ibox-content">
      <div>
        <el-card shadow="hover">
          <el-checkbox-group v-model="selectedLists" @change="handleSelectedListsChange()">
            <el-checkbox
              v-for="list in contactLists"
              :label="list.id"
              :key="list.id"
            >
              {{list.name}}
            </el-checkbox>
          </el-checkbox-group>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import contactListQuery from '@/graphql/contacts/contactList.gql';
import mailChimpListQuery from '@/graphql/contacts/mailChimpContactLists.gql';
import Loader from '@/components/common/Loader';
import { parseProviderName } from '@/helpers/contact';

export default {
  name: 'ContactListsSelect',
  components: {
    Loader,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    provider: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    contactLists: [],
    selectedLists: [],
    skipConstantContactQuery: true,
    skipMailChimpQuery: true,
  }),
  apollo: {
    $client: 'apiv2',
    constantContactLists: {
      query: contactListQuery,
      skip() { return this.skipConstantContactQuery; },
      variables() {
        return {
          id: this.id,
        };
      },
      result({ data, loading }) {
        this.contactLists = !loading ? data.constantContactLists : [];
      },
    },
    mailChimpLists: {
      query: mailChimpListQuery,
      skip() { return this.skipMailChimpQuery; },
      variables() {
        return {
          id: this.id,
        };
      },
      result({ data, loading }) {
        this.contactLists = !loading ? data.mailChimpLists : [];
      },
    },
  },
  mounted() {
    switch (this.provider) {
      case 'constant_contact':
        this.skipConstantContactQuery = false;
        this.$apollo.queries.constantContactLists.refetch({ id: this.id });
        break;
      case 'mail_chimp':
        this.skipMailChimpQuery = false;
        this.$apollo.queries.mailChimpLists.refetch({ id: this.id });
        break;
      default: break;
    }
  },
  methods: {
    parseProviderName,
    handleSelectedListsChange() {
      this.$emit('selectedListsChange', this.id, this.selectedLists);
    },
  },
};
</script>



// WEBPACK FOOTER //
// ContactListsSelect.vue?4e63d2b5